import { z } from 'zod'

export const departureSchema = z.object({
  attendanceId: z.string().uuid(),
  roomName: z.string().min(1).max(255),
  reason: z.enum(['USER_LEFT', 'CONNECTION_LOST', 'KICKED', 'NETWORK_ERROR']),
  leftAt: z.string().datetime()
}).strict()

export type MeetingDeparture = z.infer<typeof departureSchema>
